import script from "./VideoEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoEditor.vue?vue&type=script&setup=true&lang=ts"

import "./VideoEditor.vue?vue&type=style&index=0&id=0bc71a6c&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc71a6c"]])

export default __exports__